import { trackInhouseEvent } from '@/features/analytics/in-house'

import { eventBus } from '../bus'

export function registerInternal2Subscribers(events: Set<string>) {
    if (events.has('seo_description_show_more_debug')) {
        eventBus.subscribe('seo_description.show_more_clicked', (payload) => {
            if (typeof window === 'undefined') return

            trackInhouseEvent({
                event: 'seo_description_show_more_debug',
                version: 'internal_2',
                ...payload,
            })
        })
    }
}
